/**
 * ImagesSection – producer profile images using the canonical MediaImageManager.
 * Creates its own upload hooks internally for convenience.
 */

import { MediaImageManager } from '@/components/media/MediaImageManager';
import { useMediaUpload } from '@/hooks/useMediaUpload';

interface ImagesSectionProps {
  producerId?: string;
  draftSessionId?: string;
}

export function ImagesSection({
  producerId,
  draftSessionId,
}: ImagesSectionProps) {
  const effectiveDraftSessionId = draftSessionId ?? '';

  const coverUpload = useMediaUpload({
    ownerType: 'producer',
    ownerId: producerId ?? null,
    draftSessionId: !producerId ? effectiveDraftSessionId : undefined,
    kind: 'cover',
    maxFiles: 1,
  });

  const galleryUpload = useMediaUpload({
    ownerType: 'producer',
    ownerId: producerId ?? null,
    draftSessionId: !producerId ? effectiveDraftSessionId : undefined,
    kind: 'gallery',
    maxFiles: 15,
  });

  return (
    <MediaImageManager
      ownerType="producer"
      ownerId={producerId}
      producerId={producerId}
      draftSessionId={effectiveDraftSessionId}
      coverUpload={coverUpload}
      galleryUpload={galleryUpload}
      helperText="Ladda upp omslagsbild och galleri. Bilder sparas automatiskt."
    />
  );
}
